export default __webpack_public_path__ + "static/media/42_BottomRightSquares_Right.cb9b4171.mp4";